import { Product } from '../../../types/product';
import { CSVParseResult } from './types';
import { parseCSVRecords } from './lineParser';
import { buildHeaderMap, createProductFromRow, extractImageFilenames } from './productMapper';

export async function parseCSV(csvContent: string): Promise<CSVParseResult> {
  const records = parseCSVRecords(csvContent);
  const products: Product[] = [];
  const productImageFilenames: string[][] = [];
  const errors: string[] = [];

  if (records.length === 0) {
    return {
      success: false,
      products: [],
      productImageFilenames: [],
      errors: ['CSVにデータが見つかりませんでした']
    };
  }

  // Detect and consume a header row when present (the exporter always writes one).
  const firstRow = records[0];
  const hasHeader = firstRow.some(
    cell => cell.includes('カテゴリ') || cell.includes('タイトル')
  );
  const headerMap = hasHeader ? buildHeaderMap(firstRow) : null;
  const startIndex = hasHeader ? 1 : 0;

  for (let i = startIndex; i < records.length; i++) {
    const fields = records[i];

    // Skip blank rows (e.g. trailing newline).
    if (fields.every(cell => cell.trim() === '')) continue;

    try {
      const product = createProductFromRow(fields, headerMap);
      products.push(product);
      productImageFilenames.push(extractImageFilenames(fields, headerMap));
    } catch (error) {
      errors.push(`行 ${i + 1}: ${error instanceof Error ? error.message : '不明なエラー'}`);
    }
  }

  return {
    success: errors.length === 0 && products.length > 0,
    products,
    productImageFilenames,
    errors:
      products.length === 0 && errors.length === 0
        ? ['有効な商品データが見つかりませんでした']
        : errors
  };
}
